/* V13 mobile buy bar + ad-landing image match. Loaded after redacted.js as a
   separate asset so it does not depend on live/local redacted.js divergence.
   It reuses the existing product form submit handler and thumbnail handlers. */
(function () {
  var root = document.querySelector('[data-product]');
  if (!root) return;
  var form = root.querySelector('.product-form');
  var add = root.querySelector('[data-add-button]');
  var price = root.querySelector('[data-price]');
  var chosen = function () {
    var values = [];
    root.querySelectorAll('[data-option-index]:checked').forEach(function (input) { values.push(input.value); });
    return values.join(' / ');
  };
  var status = root.querySelector('[data-product-status]');
  var introPrice = root.querySelector('[data-mobile-intro-price]');
  var bar = document.querySelector('[data-mobile-buy]');
  var watch = function (node, fn) {
    if (node) new MutationObserver(fn).observe(node, { childList: true, attributes: true, characterData: true, subtree: true });
  };

  if (bar && form && add && price) {
    var barPrice = bar.querySelector('[data-mobile-buy-price]');
    var barLabel = bar.querySelector('[data-mobile-buy-label]');
    var barButton = bar.querySelector('[data-mobile-buy-add]');
    var added = false;
    var syncButton = function () {
      if (added) return;
      barButton.disabled = add.disabled;
      barButton.textContent = add.disabled ? add.textContent : 'Add to bag';
    };
    // A new size/format/edition choice resets the bar to "Add to bag".
    var syncVariant = function () {
      added = false;
      barPrice.textContent = price.textContent;
      if (introPrice) introPrice.textContent = price.textContent;
      var compare = root.querySelector('[data-compare]');
      var introCompare = root.querySelector('[data-mobile-intro-compare]');
      if (compare && introCompare) { introCompare.textContent = compare.textContent; introCompare.hidden = compare.hidden; }
      barLabel.textContent = chosen() || barLabel.textContent;
      syncButton();
    };
    watch(price, syncVariant);
    form.addEventListener('change', syncVariant);
    watch(add, syncButton);
    syncVariant();

    // The existing handler reports success in a status line far down the page;
    // turn the bar into a checkout shortcut so phone shoppers see the result.
    watch(status, function () {
      if (!/added/i.test(status.textContent)) return;
      added = true;
      barButton.disabled = false;
      barButton.textContent = 'View bag';
      barLabel.textContent = 'Added to your bag';
      bar.classList.remove('is-hidden');
    });

    barButton.addEventListener('click', function () {
      if (added) { location.href = (root.dataset.root || '/') + 'cart'; return; }
      if (add.disabled) return;
      if (form.requestSubmit) form.requestSubmit(add); else add.click();
    });
    bar.querySelector('[data-mobile-buy-change]').addEventListener('click', function () {
      (root.querySelector('[data-options]') || form).scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    // Hide the bar while the real buy button or the intro price is on screen,
    // so the price and CTA are never shown twice at once.
    if ('IntersectionObserver' in window) {
      var onScreen = new Set();
      var intro = root.querySelector('.mobile-intro');
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) onScreen.add(entry.target); else onScreen.delete(entry.target);
        });
        bar.classList.toggle('is-hidden', onScreen.size > 0 && !added);
      });
      io.observe(add);
      if (intro) io.observe(intro);
    }
    bar.hidden = false;
  }

  // Visitors from a room-scene ad land on the matching room image, not the stool.
  var params = new URLSearchParams(location.search);
  if (/room/i.test(params.get('utm_content') || '')) {
    var edition = /(^| )Dark( |$)/.test(chosen()) ? 'Dark' : 'White';
    var thumbs = root.querySelectorAll('.thumbnail-row [data-alt]');
    for (var i = 0; i < thumbs.length; i++) {
      var alt = thumbs[i].getAttribute('data-alt') || '';
      if (alt.indexOf(edition + ' Edition') > -1 && /room view/i.test(alt)) { thumbs[i].click(); break; }
    }
  }
})();
